import { Tooltip } from "@rentiohq/web-shared/dist/components";
import { IAcademyScore } from "../../RentmatchAcademy.types";
import { getAcademyText, getUiKey } from "../../RentmatchAcademy.utils";
import * as S from "./AcademyScore.styles";

interface IProps {
  score: IAcademyScore;
}

// One small label for the overview, the chapter cards and the chapter page.
// The full sentence, and that only the broker sees it, sit in the tooltip.
export const AcademyScore = (props: IProps) => {
  const { score } = props;

  if (score.answered === 0) {
    return null;
  }

  const remaining = score.total - score.answered;
  const label =
    remaining > 0
      ? getAcademyText(getUiKey("score.label"), {
          correct: `${score.correct}`,
          answered: `${score.answered}`,
          remaining: `${remaining}`,
        })
      : getAcademyText(getUiKey("score.label_done"), {
          correct: `${score.correct}`,
          answered: `${score.answered}`,
        });

  return (
    <Tooltip
      placement="bottom"
      tooltipContent={getAcademyText(getUiKey("score.tooltip"), {
        correct: `${score.correct}`,
        answered: `${score.answered}`,
        total: `${score.total}`,
      })}
    >
      <S.Label role="status">{label}</S.Label>
    </Tooltip>
  );
};
